import React, {useRef, useState} from 'react';
import {BaseInputProps} from '../..';

import {useController, useFormContext} from 'react-hook-form';
import {NestedKeys} from 'shared/types/key-manipulation';
import {
  AudioRecorder as ReactAudioRecorder,
  useAudioRecorder,
} from 'react-audio-voice-recorder';

import {Container, FileHolder, Label} from './styles';

export type AudioRecorderProps<T = any> = BaseInputProps & {
  name: NestedKeys<T>;
  gridColumn?: number;
};

const AudioRecorder: React.FC<AudioRecorderProps> = ({
  name,
  label,
  gridColumn,
  border,
}) => {
  const {control} = useFormContext();
  const {field} = useController({control, name: name!});

  const [audio, setAudio] = useState<string>();
  const recorderControls = useAudioRecorder();
  const {isRecording} = recorderControls;
  const audioRef = useRef<HTMLAudioElement>(null);

  const onRecordingComplete = (blob: Blob) => {
    recorderControls.stopRecording();
    const url = URL.createObjectURL(blob);
    field.onChange(url);
    setAudio(url);
    audioRef.current?.load();
  };

  return (
    <Container {...{gridColumn, border}}>
      <Label>{label}</Label>
      <FileHolder>
        {audio && !isRecording && (
          <audio controls ref={audioRef}>
            <source src={audio} type="audio/mpeg" />
          </audio>
        )}
        <ReactAudioRecorder {...{onRecordingComplete, recorderControls}} />
      </FileHolder>
    </Container>
  );
};

export default AudioRecorder;
